import { useEffect } from 'react';

import { ToastService } from '@core';
import { TIME_IN_MS, useOnlineStatus } from '@utils';

import { OFFLINE_MESSAGE_ID } from './App.constant';

export const useOnlineOffline = () => {
  const { isOnline } = useOnlineStatus();

  useEffect(() => {
    if (ToastService.IsActive(OFFLINE_MESSAGE_ID)) {
      ToastService.Update(
        OFFLINE_MESSAGE_ID,
        isOnline ? 'success' : 'warning',
        isOnline ? 'general.onlineMessage' : 'general.offlineMessage',
        {
          autoClose: isOnline ? TIME_IN_MS.THREE_SECONDS : false,
        }
      );
    } else if (!isOnline) {
      ToastService.Warning('general.offlineMessage', {
        autoClose: false,
        toastId: OFFLINE_MESSAGE_ID,
      });
    }
  }, [isOnline]);
};
